declare var apiConfig: any;
declare let  dataLayer: any;
export const environment = {
  production: true,
  apiUrl: apiConfig.apiGatewayURL,
  productsUrl: apiConfig.apiGatewayURL + '/product/v1/',
  uiTemplateBaseUrl: document.getElementsByTagName('base')[0].href + '/resources/static/src/assets',
  baseHref: document.getElementsByTagName('base')[0].href,
  accountThroughGateway: apiConfig.apiGatewayURL + '/account/V1/',
  auditLogURL: apiConfig.apiGatewayURL + '/audit/V1/',
  legacyLoginURL: 'https://fbosite.foreverliving.com/distribNew/Login.do;',
  ssoApiURL: apiConfig.ssoApiURL,
  ssoClientID: apiConfig.ssoClientID,
  ssoTokenURL: apiConfig.ssoTokenURL,
  ssoClientAssertion: apiConfig.ssoClientAssertion,
  shopURL: apiConfig.shopURL,
  customerName: apiConfig.customerName,
  accountUrl: apiConfig.accountUrl,
  reportApi: apiConfig.reportApi,
  externalUserLogoutUrl: apiConfig.externalUserLogoutUrl,
  trackShipmentsURL: apiConfig.trackShipmentsURL,
  cookieDomain: apiConfig.cookieDomain || '.flptitan.com',
  cookiePath: apiConfig.cookiePath || '/',
  accessToken: apiConfig.accessToken || 'IPAT_DEV',
  refreshToken: apiConfig.refreshToken || 'IPRT_DEV',
  idNonce: apiConfig.idNonce || 'IPIDNC_DEV',
  externalAccessToken: apiConfig.externalAccessToken || 'EPAT_DEV',
  externalRefreshToken: apiConfig.externalRefreshToken || 'EPRT_DEV',
  externalIdNonce: apiConfig.externalIdNonce || 'IDNC_DEV',
  disableVpnPin: apiConfig.disableVpnPin || true,
  cdnURL: apiConfig.cdnURL,
  enableAuthentication: apiConfig.enableAuthentication,
  enableAuthorization: apiConfig.enableAuthorization,
  templateVersion: 1,
  envName: apiConfig.envName,
  removeObsoleteCookies: apiConfig.removeObsoleteCookies,
  dataLayer: dataLayer,
  paymentServiceKey: apiConfig.paymentServiceKey,
  paymentSecurityKey: apiConfig.paymentSecurityKey,
  paymentApiKey: apiConfig.paymentApiKey,
  flp360LoginUrl: apiConfig.flp360LoginUrl,
  flp360TitanWebsiteUrl: apiConfig.flp360TitanWebsiteUrl,
  flp360TitanWebsiteEnabled: apiConfig.flp360TitanWebsiteEnabled,
  enableLongPoll: apiConfig.enableLongPoll,
  longPollCount: apiConfig.longPollCount,
  sessionLogoutInterval: apiConfig.sessionLogoutInterval,
  sessionPopupInterval: apiConfig.sessionPopupInterval,
  draftEmailAttachmentsSize: apiConfig.draftEmailAttachmentsSize,
  maxSearchResultsSize: apiConfig.maxSearchResultsSize || 25,
  bfpoInstructionsUrl: apiConfig.bfpoInstructionsUrl,
  ssoInternalUserCacheUrl: apiConfig.ssoInternalUserCacheUrl,
  enableWHLSAL00ForAsstSupervisor: apiConfig.enableWHLSAL00ForAsstSupervisor,
  maxlimit: apiConfig.maxlimit || 9,
  hideFPCEnrollmentItem: apiConfig.hideFPCEnrollmentItem,
  corporateSiteUrl: apiConfig.corporateSiteUrl,
  enableCloneOrderCountries: apiConfig.enableCloneOrderCountries,
  betaEnabledCountries: apiConfig.betaEnabledCountries || '',
  enableSponsorChange: apiConfig.enableSponsorChange || false,
  s3BaseUrl: apiConfig.s3BaseUrl || 'https://titandevenv.s3.us-west-2.amazonaws.com/',
  freeShippingExpiryDays: apiConfig.freeShippingExpiryDays,
  flp360BaseURL: apiConfig.flp360BaseURL,
  enableFLP360ReportPage: apiConfig.enableFLP360ReportPage,
  enableServiceOrder: apiConfig.enableServiceOrder || false,
  enableFileUploads: apiConfig.enableFileUploads,
  scandinavianCountries: apiConfig.scandinavianCountries,
  scanGoLiveDate: apiConfig.scanGoLiveDate,
  deuCountries: apiConfig.deuCountries,
  deuGoLiveDate: apiConfig.deuGoLiveDate,
  enableReports: apiConfig.enableReports || false,
  reportDownloadDurationMonths: apiConfig.reportDownloadDurationMonths || 6 ,
  liveCountries: apiConfig.liveCountries,
  beneluxCountries: apiConfig.beneluxCountries,
  portalUrl : apiConfig.portalUrl,
  ttsInternalEmailId: apiConfig.ttsInternalEmailId,
  enableEmailConfiguration: apiConfig.enableEmailConfiguration || false,
  enableFDTicketsTab:  apiConfig.enableFDTicketsTab || false,
  enableOrderStatusChangeConfiguration:  apiConfig.enableOrderStatusChangeConfiguration || false,
  chargebeeSiteName: 'flpi-anonymous-retail-test',
  chargebeePublishableKey: 'test_vcCMJaZXcUhcGmSS3PWQn73pMDc1KI0E',
  // enableNexioPaymentProcessor: apiConfig.enableNexioPaymentProcessor,
  apiTBEUrl: apiConfig.apiTBEGatewayURL || 'https://apigw-tbedev.flptitan.com/api/bonusengine/',
  enableAnonymousRetailOrders:apiConfig.enableAnonymousRetailOrders || false,
  restrictGoogleMapNavigation: apiConfig.restrictGoogleMapNavigation,
  disableStateCountries: apiConfig.disableStateCountries || "ILN,BEL,NLD,LUX",
  adminURL: apiConfig.adminUrl,
  enableRetailFreeShipping: apiConfig.enableRetailFreeShipping || false,
  retailFreeShippingEnabledCountries: apiConfig.retailFreeShippingEnabledCountries,
  // worldpayPaymentCountries: apiConfig.worldpayPaymentCountries
  enableFileUploadToPrivate: apiConfig.enableFileUploadToPrivate || false,
  sponsorSearchTimeDelay: apiConfig.sponsorSearchTimeDelay,
  enableNexioPaymentForPickUpCenter: apiConfig.enableNexioPaymentForPickUpCenter || false,
  enableFLP360ImpersonationForFPC: apiConfig.enableFLP360ImpersonationForFPC,
  terminalPaymentStatusCheckPollingCount: apiConfig.terminalPaymentStatusCheckPollingCount,
  isEnabledOfflineTitanFlow : apiConfig.enableOfflineTitanFlow || false,
  enableNewAggregation: apiConfig.enableNewAggregation || false,
  removeCommaOnInvoice : apiConfig.removeCommaOnInvoice ||'DEU,AUT,CHE',
  hidePCSponsorshipCountries : apiConfig.hidePCSponsorshipCountries || 'USA',
  skipOrderRestrictionCountriesOnSPNCTransaction : apiConfig.skipOrderRestrictionCountriesOnSPNCTransaction || ['GBR', 'ILN'],
  ignoreDisableAddNewCardCheckCountries : apiConfig.ignoreDisableAddNewCardCheckCountries || '',
  retirementNotice: apiConfig.retirementNotice
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts